import { useEffect, useRef, useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';
import { NotFoundException } from '@zxing/library';

const useZxingScanner = ({ onResult, onError, active }) => {
  const videoRef = useRef(null);
  const readerRef = useRef(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!active) return;

    const codeReader = new BrowserMultiFormatReader();
    readerRef.current = codeReader;

    let cancelled = false;

    const startScanning = async () => {
      try {
        const videoInputDevices = await BrowserMultiFormatReader.listVideoInputDevices();
        // Prefer rear camera on mobile
        const selectedDevice = videoInputDevices.find(d =>
          d.label.toLowerCase().includes('back') ||
          d.label.toLowerCase().includes('rear') ||
          d.label.toLowerCase().includes('environment')
        ) || videoInputDevices[videoInputDevices.length - 1];

        if (!selectedDevice) {
          onError?.('No camera found on this device.');
          return;
        }

        if (!videoRef.current) return;

        setIsReady(true);

        await codeReader.decodeFromVideoDevice(
          selectedDevice.deviceId,
          videoRef.current,
          (result, err) => {
            if (cancelled) return;
            if (result) {
              onResult(result.getText());
            }
            if (err && !(err instanceof NotFoundException)) {
              console.warn('[ZXing]', err);
            }
          }
        );
      } catch (err) {
        console.error('[ZXing] Camera error:', err);
        onError?.('Camera access denied or unavailable.');
      }
    };

    startScanning();

    return () => {
      cancelled = true;
      try {
        BrowserMultiFormatReader.releaseAllStreams();
      } catch (_) {}
      setIsReady(false);
    };
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps

  return { videoRef, isReady };
};

export default useZxingScanner;
